import { useAddressApi } from "../api/AddressApiClient";
import { AddressFrontendService } from "../services/AddressFrontendService";

export const useAddressService = (): AddressFrontendService =>
  new AddressFrontendService(useAddressApi());
